export default __webpack_public_path__ + "media/images/user_photos/99-a04ebae277f4b6519dcc406dcc2125c4.jpg";